import { useMemo } from 'react';

import useLocalStorage from '@zenbusiness/application-commons-hooks/useLocalStorage';

import FLOW_CONFIG from '#client/config/flowConfig';
import { LOCAL_STORAGE_FLOW_STATES_KEY } from '#client/constants/localStorage';

/** @typedef {import('react')} React */

/**
 * FlowStateCleaner component is responsible for cleaning up flow states stored in local storage.
 * It removes any flow states that are not part of the active flows defined in FLOW_CONFIG.
 *
 * @returns {boolean} Always returns false.
 */
function FlowStateCleaner() {
  const [flowStates, setFlowStates] = useLocalStorage(
    LOCAL_STORAGE_FLOW_STATES_KEY,
    {},
    { isJSON: true }
  );

  // verify the flows just one time
  useMemo(() => {
    const activeFlows = FLOW_CONFIG.map((flow) => flow.id);

    Object.keys(flowStates).forEach((flowId) => {
      if (!activeFlows.includes(flowId)) {
        delete flowStates[flowId];
      }
    });

    setFlowStates(flowStates);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return false;
}

export default FlowStateCleaner;
